import React, {useEffect} from "react";
import forwardHead from "../../../assets/img/exercises/exerciseIcon-base64/forwardHead";
import selectedMovementCancelBtn from "../../../assets/img/movement/selectedMovementCancelBtn.svg";
import CONSTANT from "../../../constants/Constant";
import {_getStatusName, getExerciseStatusStyle} from "../../../utils/Movement";

const SelectedMovementBox = ({selectedExercise, hideMovementBox, isAllCompleted}) => {

    useEffect(() => {
        if (isAllCompleted) {
            hideMovementBox();
        }
    }, [isAllCompleted]);

    return (
        <>
            <div className="row movement-shadow-box-top justify-between">
                <div className="col-md-10 font-size-19">
                    <div>
                        <span className="kt-widget2__icon kt-pr15">
                            <img src={forwardHead} alt="movement icon"/>
                        </span>
                        {selectedExercise.ExerciseDisplayName}
                    </div>
                    <div className="performing-text-container">
                        <span>
                            <small className="color-red-2">Performing</small>
                        </span>
                    </div>
                </div>
                <div className="col-md-2">
                    {selectedExercise?.IsUserCanSkip && (
                        <button className="movement-cancel-btn" onClick={hideMovementBox}>
                            <img src={selectedMovementCancelBtn} alt="movement cancel icon"/>
                        </button>
                    )}
                </div>
            </div>
        </>
    );
}

export default SelectedMovementBox;